import React, { ReactNode, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import "./CartBetScroller.module.scss";

const CartBetScroller = ({ children }) => {
	const paginationTimeout = React.useRef(null);
	const firstBetItemRef = React.useRef(null);
	const scrollerRef = React.useRef(null);
	const [currentPage, setCurrentPage] = React.useState(1);
	const betItemWidth = (firstBetItemRef.current && firstBetItemRef.current.offsetWidth) || 1;
	const childCount = React.Children.toArray(children).filter(child =>
		React.isValidElement(child),
	).length;

	const betItemWidthWithGap = React.useRef(0);

	function updatePagination() {
		clearTimeout(paginationTimeout.current);

		paginationTimeout.current = setTimeout(() => {
			const scrollerLeftPosition = (scrollerRef.current && scrollerRef.current.scrollLeft);
			const scrollerScrollWidth = (scrollerRef.current && scrollerRef.current.scrollWidth);
			const scrollerOffsetWidth = (scrollerRef.current && scrollerRef.current.offsetWidth);

			if (
				!scrollerLeftPosition ||
				!scrollerScrollWidth ||
				!scrollerOffsetWidth ||
				!betItemWidth
			)
				return;

			const currentPage =
				(scrollerLeftPosition + betItemWidthWithGap.current / 2) /
				betItemWidthWithGap.current;

			const adjustedCurrentPage =
				currentPage < 1 ? 1 : Math.round(currentPage) + 1;

			setCurrentPage(adjustedCurrentPage);
		}, 10);
	}

	function goToPage(pageNumber) {
		if (scrollerRef.current) {
			scrollerRef.current.scrollTo({
				left: pageNumber * betItemWidthWithGap.current,
				behavior: "smooth",
			});
		}
	}

	const betElements = React.Children.map(children, (child, index) => {
		if (!React.isValidElement(child)) return;

		if (index === 0)
			return React.cloneElement(child, {
				ref: firstBetItemRef,
			});

		return child;
	});

	React.useEffect(() => {
		if (scrollerRef.current) {
			scrollerRef.current.addEventListener("scroll", updatePagination, {
				passive: true,
			});
		}

		return () => {
			if (scrollerRef.current) {
				scrollerRef.current.removeEventListener(
					"scroll",
					updatePagination,
				);
			}
		};
	}, []);

	React.useEffect(() => {
		if (scrollerRef.current) {
			const gapStyle = getComputedStyle(scrollerRef.current).gap || "0";
			const gapValue = Number(/\d+/g.exec(gapStyle));
			betItemWidthWithGap.current = betItemWidth + gapValue;
		}
	}, [betItemWidth]);

	return (
		<React.Fragment>
			<div className={"betScroller__betScroller"} ref={scrollerRef}>
				{betElements}
			</div>
			{/* <div className={"betScroller__paginator"}>
				{Array.from({ length: childCount }).map((_, pageIndex) => {
					return (
						<span
							key={`pag-dot-${pageIndex}`}
							onClick={() => goToPage(pageIndex)}
							className={[
								"betScroller__paginationDot",
								pageIndex + 1 === currentPage && "betScroller__active",
							].filter(i=>i).join(" ")}
						/>
					);
				})}
			</div> */}
		</React.Fragment>
	);
};

module.exports = CartBetScroller;



// WEBPACK FOOTER //
// ./src/rifa/components/layout/cart/CartBetScroller.jsx